import ChartUiDomainBase from "./base/ChartUiDomainBase";

export default class ChartUiDomain extends ChartUiDomainBase {
  constructor() {
    super();
  }
}
